import { render, staticRenderFns } from "./PonudaStavkaEdit.vue?vue&type=template&id=3f75e462"
import script from "./PonudaStavkaEdit.vue?vue&type=script&lang=js"
export * from "./PonudaStavkaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports